import { render, staticRenderFns } from "./UpdatePfType.vue?vue&type=template&id=628a4d38"
import script from "./UpdatePfType.vue?vue&type=script&lang=js"
export * from "./UpdatePfType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports